export class Controller {

    /** @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;
    }

    $onChanges({options}) {
        if (options && !options.isFirstChange()) {
            this.update(options.currentValue || {});
        }
    }

    update({key, autoDismiss}) {
        this.visible = !!key;

        if (autoDismiss) {
            this.$timeout(4000)
                .then(() => this.visible = false);
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-alert/sp-alert.controller.js